import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";
import axios from "axios";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
} from "../../../helpers/fakebackend_helper";

const fireBaseBackend = getFirebaseBackend();

// function* loginUser({ payload: { user, history } }) {
//   try {
//      console.log("Payload from component:", { user, history }); 
//     const response = yield call(axios.post,
//       `${process.env.REACT_APP_API_BASE_URL}/adminLogin/admin/`,
//       {
//         email: user.email,
//         password: user.password
//       },
//       {
//         headers: { 'Content-Type': 'application/json' }
//       }
//     );

//     const res = response.data;


//     if (res?.status === "success" && res.data) {

//       let admin_data = res.data;
//       let pk_admin_key = res.data.pk_admin_key;

//       sessionStorage.setItem("pk_admin_key", pk_admin_key);
//       sessionStorage.setItem("admin_data", JSON.stringify(admin_data));

//       yield put(loginSuccess(admin_data));
//       history("/scan-qr-code");
//     } else {
//       yield put(apiError("Invalid Credentials"));
//     }


//   } catch (error) {
//     if (error.response) {
//       yield put(apiError(error.response.data.message || "API Error"));
//     } else {
//       yield put(apiError("Network Error"));
//     }
//   }
// }

function* loginUser({ payload: { user, history } }) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_BASE_URL}/adminLogin/admin/`,
      {
        email: user.email,
        password: user.password
      },
      { headers: { "Content-Type": "application/json" } }
    );

    const res = response.data;

    if (res?.status === "success" && res.data) {

      const data = res.data;
      const role = res.role; 

      if (role === "admin") {
        sessionStorage.setItem("role", "admin");
        sessionStorage.setItem("pk_admin_key", data.pk_admin_key);
        sessionStorage.setItem("admin_data", JSON.stringify(data));

        yield put(loginSuccess({ ...data, role }));

        window.dispatchEvent(new Event("roleChanged"));

        history("/admin/scan-qr-code");
        return;
      }


      if (role === "farm_user") {
        sessionStorage.setItem("role", "farm_user");
        sessionStorage.setItem("pk_farm_key", data.pk_farm_key);
        sessionStorage.setItem("farm_user_data", JSON.stringify(data));

        yield put(loginSuccess({ ...data, role }));
        window.dispatchEvent(new Event("roleChanged"));
        history("/scan-qr-code");
        return;
      }

      // Unknown role (should not happen)
      yield put(apiError("Unknown role received from server"));
      return;
    }

    // Login error
    yield put(apiError("Invalid Credentials"));

  } catch (error) {
    yield put(apiError("Login failed"));
  }
}



function* logoutUser({ payload: { history } }) {
  try {

    sessionStorage.removeItem("role");
    sessionStorage.removeItem("pk_admin_key");
    sessionStorage.removeItem("admin_data");
    sessionStorage.removeItem("pk_farm_key");
    sessionStorage.removeItem("farm_user_data");

    // (Optional) remove old key if exists
    sessionStorage.removeItem("authUser");
    sessionStorage.clear();
    window.dispatchEvent(new Event("roleChanged"));

    // Firebase logout if enabled
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }

    // Redirect to login
    history("/login");

  } catch (error) {
    yield put(apiError(error));
  }
}


function* socialLogin({ payload: { type, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, type);
      if (response) {
        history("/batch-details");
      } else {
        history("/login");
      }
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    const response = yield call(fireBaseBackend.socialLoginUser, type);
    if (response)
      history("/batch-details");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
